/* In-place category switching for the collection tabs. Clicking a
 * tab fetches just the product grid and the tabs strip for the target
 * collection through the Section Rendering API and swaps them in,
 * instead of reloading the whole page. The URL updates so links,
 * refresh and back/forward keep working; Dawn's facet filtering keeps
 * working because it always renders against window.location.
 */
(() => {
  const tabsRoot = document.querySelector('.vitae-coltabs');
  const grid = document.getElementById('product-grid');
  if (!tabsRoot || !grid) return;

  const tabsSection = tabsRoot.closest('.shopify-section');
  const gridSection = document.getElementById('shopify-section-' + grid.dataset.id);
  if (!tabsSection || !gridSection) return;

  const tabsId = tabsSection.id.replace('shopify-section-', '');
  const gridId = grid.dataset.id;
  let currentPath = window.location.pathname;
  let inflight = null;

  const sectionHTML = async (url, id) => {
    const res = await fetch(`${url}?section_id=${id}`, { headers: { Accept: 'text/html' } });
    if (!res.ok) throw new Error(res.status);
    const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
    return doc.getElementById('shopify-section-' + id)?.innerHTML ?? doc.body.innerHTML;
  };

  const render = async (path, pushHistory) => {
    const container = document.getElementById('ProductGridContainer');
    container?.classList.add('is-switching');
    tabsRoot.querySelectorAll('.vitae-coltabs__tab').forEach((t) => {
      t.classList.toggle('is-loading', t.getAttribute('href') === path);
    });

    const job = Promise.all([sectionHTML(path, gridId), sectionHTML(path, tabsId)]);
    inflight = job;
    try {
      const [gridHTML, tabsHTML] = await job;
      if (inflight !== job) return;
      gridSection.innerHTML = gridHTML;
      tabsSection.innerHTML = tabsHTML;
      /* Injected cards would otherwise wait for a scroll-in animation */
      gridSection.querySelectorAll('.scroll-trigger').forEach((el) => el.classList.add('scroll-trigger--pre-rendered'));
      currentPath = path;
      if (pushHistory) history.pushState({ searchParams: '', vitaeCollection: path }, '', path);
      if (window.FacetFiltersForm) {
        window.FacetFiltersForm.searchParamsInitial = '';
        window.FacetFiltersForm.searchParamsPrev = '';
      }
      const top = tabsSection.getBoundingClientRect().top;
      if (top < 0) tabsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } catch (e) {
      window.location.assign(path);
    } finally {
      document.getElementById('ProductGridContainer')?.classList.remove('is-switching');
    }
  };

  /* Delegated: the tabs strip is replaced on every switch */
  document.addEventListener('click', (e) => {
    const tab = e.target.closest('.vitae-coltabs__tab');
    if (!tab || !tabsSection.contains(tab)) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    const url = new URL(tab.href, window.location.origin);
    if (url.origin !== window.location.origin) return;
    e.preventDefault();
    if (url.pathname === currentPath) return;
    render(url.pathname, true);
  });

  window.addEventListener('popstate', () => {
    if (window.location.pathname !== currentPath) render(window.location.pathname, false);
  });
})();
